import {
  FormPageAuthInputItemMailAddressFree,
  FormPageInputItemMailAddressAtSignSeparated,
  FormPageInputItemMailAddressDomainPulldown,
  FormPageInputItemMailAddressFree,
  MailAddressPropertyAtSignSeparated,
  MailAddressPropertyDomainPulldown,
} from 'shared';
import { buildStringWithDelimiter, isAllStringsFalsy } from './shared';

const convertFree = (mailAddress?: string): string | undefined => {
  if (mailAddress === '') {
    return undefined;
  }
  return mailAddress;
};

export const convertMailAddressFree = (
  value: FormPageInputItemMailAddressFree
): string | undefined => {
  return convertFree(value.mailAddress);
};

export const convertMailAddressAtSignSeparated = (
  value: FormPageInputItemMailAddressAtSignSeparated,
  property: MailAddressPropertyAtSignSeparated
): string | undefined => {
  const { local, domain } = value;
  const { delimiter } = property.inputFormat;
  if (isAllStringsFalsy(local, domain)) {
    return undefined;
  }
  return buildStringWithDelimiter([local, domain], delimiter);
};

export const convertMailAddressDomainPulldown = (
  value: FormPageInputItemMailAddressDomainPulldown,
  property: MailAddressPropertyDomainPulldown
): string | undefined => {
  const { local, domain } = value;
  const { delimiter } = property.inputFormat;
  if (local == null || local === '') {
    return undefined;
  }
  return buildStringWithDelimiter([local, domain], delimiter);
};

export const convertAuthMailAddressFree = (
  value: FormPageAuthInputItemMailAddressFree
): string | undefined => {
  return convertFree(value.mailAddress);
};
